import PaymentsIcon from "@mui/icons-material/Payments";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";

export const mboSalePaymentDashboardServices = {
	sale_working: {
		name: "Sale Working",
		key: "sale_working",
		display: true,
		icon: <PaymentsIcon />,
		types: {
			sale_data: {
				name: "Sale Data & Offers",
				description:
					"Upload sale CSV, sync to BigQuery, and run offer application in one workflow.",
				key: "sale_data",
				display: true,
				icon: <UploadFileIcon />,
			},
			dashboard: {
				name: "Dashboard",
				description:
					"Download payment working results by bill date range as CSV.",
				key: "dashboard",
				display: true,
				icon: <DashboardOutlinedIcon />,
			},
			offers: {
				name: "Offer Checker",
				description:
					"Look up a barcode and bill date to see which offers apply — and why.",
				key: "offers",
				display: true,
				icon: <LocalOfferOutlinedIcon />,
			},
		},
	},
};
